<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import $ from "jquery";
import Decimal from 'decimal.js';
export default {
  name: 'App',
  provide () { // 注册一个方法
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted () {
    this.reSize();
    window.addEventListener(['resize'], this.reSize);
  },
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    reSize () {
      // let style = document.getElementsByTagName('body')[0].style;
      let style = document.getElementById('app').style;

      let winW = Math.min($(window).width());
      let winH = Math.min($(window).height());

      let scale = winW >= 1920 ? new Decimal(1) : new Decimal(winW).dividedBy(new Decimal(1920));

      let practicalW = new Decimal(winW).dividedBy(scale).toString();
      let practicalH = new Decimal(winH).dividedBy(scale).toString();

      style.setProperty('width', practicalW + "px");
      style.setProperty('height', practicalH + "px");
      style.setProperty('transform', "scale(" + scale + ")");
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  transform-origin: left top;
}
body {
}
.ant-message {
  z-index: 101011 !important;
}
</style>
